import { render } from "./ProdutosDescricao.vue?vue&type=template&id=6591d8bf&scoped=true"
import script from "./ProdutosDescricao.vue?vue&type=script&lang=js"
export * from "./ProdutosDescricao.vue?vue&type=script&lang=js"

import "./ProdutosDescricao.vue?vue&type=style&index=0&id=6591d8bf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6591d8bf"]])

export default __exports__